import { colors } from '@styles/colors'
import { zIndexes } from '@styles/z-indexes'
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ROLE,
  SIZE,
} from 'baseui/modal'
import { useStyletron } from 'styletron-react'
import { BaseButton } from '../base-button'
import { HeadingS, ParagraphM } from '../base-typography'
import { useModalScrollBar } from './hooks/use-modal-scroll-bar'

export type AlertType = 'success' | 'warning' | 'error'

interface AlertModalProps {
  onClose: () => void
  isOpen: boolean
  title: string
  description?: string
  label?: string
  type?: AlertType
}

export const AlertModal = ({
  onClose,
  isOpen,
  title,
  description,
  label = '확인',
  type = 'warning',
}: AlertModalProps) => {
  const [css] = useStyletron()
  useModalScrollBar(isOpen)

  return (
    <Modal
      onClose={onClose}
      isOpen={isOpen}
      closeable
      animate
      size={SIZE.default}
      role={ROLE.dialog}
      autoFocus={false}
      overrides={{
        Root: {
          style: {
            zIndex: zIndexes.alretModal,
          },
        },
      }}
    >
      <ModalHeader>
        <HeadingS whiteSpace="pre-wrap" minHeight="32px">
          {title}
        </HeadingS>
      </ModalHeader>
      {description && (
        <ModalBody>
          <ParagraphM
            color={colors.gray500}
            whiteSpace="pre-wrap"
            minHeight="16px"
          >
            {description}
          </ParagraphM>
        </ModalBody>
      )}
      <ModalFooter
        className={css({
          display: 'flex',
          gap: '16px',
          justifyContent: 'flex-end',
          marginBottom: '12px',
        })}
      >
        <BaseButton
          $type="secondary"
          fluid
          onClick={onClose}
          overrides={{
            BaseButton: {
              style: {
                backgroundColor:
                  type === 'warning' ? colors.red50 : colors.blue50,
                color: type === 'warning' ? colors.red400 : colors.blue400,
                ':hover': {
                  backgroundColor:
                    type === 'warning' ? colors.red100 : colors.blue100,
                  color: type === 'warning' ? colors.red400 : colors.blue400,
                },
              },
            },
          }}
        >
          {label}
        </BaseButton>
      </ModalFooter>
    </Modal>
  )
}
